import styled from 'styled-components';

const ControlsWrapper = styled.div`
   display: flex;
   align-items: center;
   min-height: var(--header-height);

   display: flex;
   justify-content: space-between;
   button {
      padding: 0.5em 1em;
      margin-right: 1em;

      :last-child {
         margin-right: 0;
      }
   }
`;

export { ControlsWrapper };
